// The column is tinyint, boolean or varchar depending on the clinic's engine, so "0" must not read as truthy.
export const isAuthSampleActive = (value: unknown): boolean => Number(value) === 1;

const normaliseSampleId = (value: unknown): string => String(value ?? "").trim().toUpperCase();

// The database collation treats case and trailing spaces as equal; an exact match missed those rows.
export const sameSampleId = (a: unknown, b: unknown): boolean => {
	const left = normaliseSampleId(a);
	return left !== "" && left === normaliseSampleId(b);
};

export const findAuthSample = <T extends { sampleID?: unknown }>(rows: T[] | null | undefined, sampleId: unknown): T | undefined =>
	(rows ?? []).find((row) => sameSampleId(row.sampleID, sampleId));
